import { PNGS } from '../assets';

export const choosePlanCarousalImages = [
  PNGS.ChoosePlanCarousalImg1,
  PNGS.ChoosePlanCarousalImg2,
  PNGS.ChoosePlanCarousalImg3,
  PNGS.ChoosePlanCarousalImg4,
  PNGS.ChoosePlanCarousalImg5,
];
